import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './QuestionBlock.module.scss';
import classNames from 'classnames';
import WrongAnswerDialog from './WrongAnswerDialog';
import RightAnswerDialog from './RightAnswerDialog';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './DialogAppearTransition.scss';
import Discussion from './Discussion';
import {playAudio} from './mediaBundle';

export default class QuestionBlock extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onUpdateUserChoice: PropTypes.func.isRequired,
        onFinishScenario: PropTypes.func.isRequired,
    };

    timers = [];

    addTimeout(fn, delay) {
        this.timers.push(setTimeout(fn, delay));
    }

    componentDidMount() {
        for (let i = 0; i < 4; i++) {
            this.addTimeout(() => playAudio('showMCQ'), 700 + i * 125);
        }
    }

    componentWillUnmount() {
        this.timers.forEach(clearTimeout);
    }

    render() {
        const {game, onUpdateUserChoice, onFinishScenario} = this.props;
        const {scenario, userChoice} = game;

        return (
            <div className={styles.questionBlock}>
                <header className={styles.question}>
                    <div dangerouslySetInnerHTML={{__html: scenario.secondQuestion}} />
                </header>

                <div className={styles.answers}>
                    {scenario.answers.map(this.renderAnswer)}
                </div>

                <ReactCSSTransitionGroup
                    transitionName='dialog-appear'
                    transitionEnterTimeout={800}
                    transitionLeaveTimeout={800}
                >
                    {userChoice.discussion ? (
                        <Discussion
                            key='discussion'
                            scenario={scenario}
                            onClose={onFinishScenario}
                        />
                    ) : (
                        <div key='answers'>
                            {scenario.answers.map(this.renderAnswerModals)}
                        </div>
                    )}
                </ReactCSSTransitionGroup>
            </div>
        );
    }

    renderAnswer = (answer, index) => {
        const {
            game: {scenario, userChoice},
        } = this.props;

        const isSelected = index === userChoice.answerIndex;
        const answerRight = scenario.answers[index].right;
        const answerWrong = !answerRight;
        const selectedRightAnswer = isSelected && answerRight;
        const selectedWrongAnswer = isSelected && answerWrong;

        const answerClassName = classNames(styles.answerItem, {
            [styles.answerItemWrong]: selectedWrongAnswer,
            [styles.answerItemRight]: selectedRightAnswer,
        });

        return (
            <div
                key={index}
                className={styles.answerItemAnimationWrapper}
                onClick={this.selectAnswer(index, answerRight)}
            >
                <div key={userChoice.answerKey} className={answerClassName}>
                    <div className={styles.answerItemCircle}>
                        {selectedRightAnswer && <div className={styles.markSign} />}
                    </div>
                    <div className={styles.answerText}>
                        <div dangerouslySetInnerHTML={{__html: answer.text}} />
                    </div>
                </div>
            </div>
        );
    };

    renderAnswerModals = (answer, index) => {
        const {
            game: {userChoice},
        } = this.props;

        if (!answer.right && !answer.error) {
            return null;
        }

        const selected = userChoice.answerIndex === index;
        const visible = !userChoice.answerShowDelayed && selected;

        const AnswerDialog = answer.right ? RightAnswerDialog : WrongAnswerDialog;

        return (
            <AnswerDialog
                key={index}
                visible={visible}
                onClose={this.closeAnswerDialog(answer)}
            >
                {this.renderAnswerDialogContent(answer)}
            </AnswerDialog>
        );
    };

    renderAnswerDialogContent(answer) {
        const {
            game: {scenario, userChoice},
        } = this.props;

        if (answer.error) {
            return <div dangerouslySetInnerHTML={{__html: answer.error}} />;
        }

        const noteIndex = userChoice.noteIndex || 0;
        const note = scenario.notes[noteIndex];

        if (_.isString(note)) {
            return <div key={noteIndex} dangerouslySetInnerHTML={{__html: note}} />;
        }

        return <div key={noteIndex}>{note}</div>;
    }

    selectAnswer = (answerIndex, isRightAnswer) => () => {
        const {
            game: {userChoice},
        } = this.props;

        if (isRightAnswer) {
            playAudio('rightAnswer');
        } else {
            playAudio('wrongAnswer');
        }

        this.props.onUpdateUserChoice({
            answerIndex,
            answerKey: (userChoice.answerKey || 0) + 1,
            answerShowDelayed: true,
        });

        this.addTimeout(() => {
            this.props.onUpdateUserChoice({
                answerShowDelayed: false,
            });
        }, 1000);
    };

    closeAnswerDialog = answer => () => {
        const {
            game: {userChoice},
        } = this.props;

        if (answer.right) {
            return this.handleCloseRightAnswerDialog();
        }

        this.props.onUpdateUserChoice({
            answerIndex: -1,
            answerKey: (userChoice.answerKey || 0) + 1,
        });
    };

    handleCloseRightAnswerDialog() {
        const {
            game: {userChoice, scenario},
        } = this.props;

        const nextNoteIndex = (userChoice.noteIndex || 0) + 1;
        const canSwitchAnswerNote = nextNoteIndex < scenario.notes.length;

        const changes = {};
        if (canSwitchAnswerNote) {
            changes.noteIndex = nextNoteIndex;
        } else {
            changes.discussion = true;
        }

        this.props.onUpdateUserChoice(changes);
    }
}
